import { css } from "@linaria/core";
import React from "react";
import Spinner from "@ui/Spinner";
import Text from "@ui/Text";
import { colors, spacings } from "@ui/Theme";
import t from "../../../../i18n";
import classNames from "classnames";

interface IconProps {
  size?: keyof typeof iconSizes;
}
const iconSizes = {
  s: 32,
  m: 54,
};

export function FaultEventLoading({
  className,
  size = "s",
}: {
  className?: string;
  size?: IconProps["size"];
}) {
  return (
    <div className={classNames(widgetLoading, className)}>
      <Spinner style={{ width: iconSizes[size] }} className={widgetLoadingSpinner} />
      <Text type="body1SemiBold">{t("project.fault_events.loading")}</Text>
      <Text type="body2" className={widgetLoadingText}>
        {t("project.fault_event.loading")}
      </Text>
    </div>
  );
}

//#region CSS
const widgetLoading = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  color: ${colors.carbon900};
`;

const widgetLoadingSpinner = css`
  height: 32px;
  width: 32px;
  margin-bottom: ${spacings.m};
`;

const widgetLoadingText = css`
  margin-top: ${spacings.xxs};
  color: ${colors.carbon800};
  text-align: center;
`;

//#endregion CSS
